import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { TranslationUseCase } from 'src/app/use-case/translation/translation.use-case';
import { getMilliseconds, getSeconds } from '../../utils/date-time.utils';
import { DateTimeService } from './date-time.service';

@Injectable({
  providedIn: 'root'
})
export class RealDateTimeService extends DateTimeService {

  private subscription: Subscription | null;

  constructor(
    private readonly translationUseCase: TranslationUseCase
  ) {
    super();

    this.subscription =  this.translationUseCase
      .getLanguageChangeStream()
      .subscribe((languageChangeEvent) => {
        const locale = languageChangeEvent.language;
        const formatsString = languageChangeEvent.translations.DATETIME_FORMATS;
        const formats = JSON.parse(formatsString);

        this.setDateTimeFormats(locale, formats);
      });
  }

  // set date formats for locale
  setDateTimeFormats(locale, formats) {
    // formats = this.dateTimeData[locale];

    moment.locale(locale, formats);

    moment.updateLocale(locale, {
      meridiem(hour, minute, isLowercase) {
        if (hour < 12) {
          return formats.meridiem.am;
        } else {
          return formats.meridiem.pm;
        }
        // if (hour < 9) {
        //     return "早上";
        // } else if (hour < 11 && minute < 30) {
        //     return "上午";
        // } else if (hour < 13 && minute < 30) {
        //     return "中午";
        // } else if (hour < 18) {
        //     return "下午";
        // } else {
        //     return "晚上";
        // }
      }
    });
  }

  // for daily surveys
  ymdToLongDate(val) {
    return moment(val, 'YYYYMMDD').format('lll');
  }

  getNowMilliseconds() {
    return moment().valueOf();
  }

  // used for feedback
  getNowSeconds() {
    return moment().unix();
  }

  // used in logger
  getNowTime() {
    return moment().format('H:mm:ss');
  }

  getTimeFromTimestamp(ts) {
    return moment.unix(ts).format('H:mm:ss');
  }

  // used in initializer to calculate base config values
  getSeconds(hours, minutes, seconds) {
    return getSeconds(hours, minutes, seconds);
  }

  // used in initializer to calculate base config values
  getMilliseconds(hours, minutes, seconds) {
    return getMilliseconds(hours, minutes, seconds);
  }

  olderThan24Hours(timestamp) {
    return timestamp && parseInt(timestamp, 10) < this.getNowSeconds() - 24 * 60 * 60;
  }
}
